<template>
    <span>{{ displayText }}</span>
  </template>
  
  <script>
  export default {
    name: 'ReBackTimer',
    props: {
      time: {
        type: String,
        required: true,
        validator: (value) => {
          // Простая проверка формата, например: "2025-09-15 00:00:00"
          return /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value);
        }
      }
    },
    data() {
      return {
        currentTime: Date.now()
      };
    },
    computed: {
      targetDate() {
        // Преобразуем строку в объект Date
        return new Date(this.time.replace(' ', 'T')); // Для совместимости с ISO
      },
      timeLeft() {
        const now = this.currentTime;
        const diff = this.targetDate - now;
        if (diff <= 0) return 0;
        return diff;
      },
      displayText() {
        if (this.timeLeft === 0) {
        return 'Время истекло';
        }

        const days = Math.floor(this.timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((this.timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((this.timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((this.timeLeft % (1000 * 60)) / 1000);

        const units = [
        { value: days, label: 'д' },
        { value: hours, label: 'ч' },
        { value: minutes, label: 'м' },
        { value: seconds, label: 'с' }
        ];

        let started = false; // флаг: начали ли мы добавлять значения
        const parts = [];

        units.forEach(unit => {
        if (!started) {
            if (unit.value > 0) {
            started = true; // начинаем добавлять с этого момента
            }
        }
        if (started) {
            parts.push(`${unit.value}${unit.label}`);
        }
        });

        // Если ничего не добавлено (например, осталось 0 времени, но ещё не истекло),
        // то хотя бы покажем последние секунды
        if (parts.length === 0) {
            return `${seconds}с`;
        }

        return parts.join(' ');
    }
    },
    mounted() {
      this.timer = setInterval(() => {
        this.currentTime = Date.now();
      }, 1000);
    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }
  };
  </script>
  
  <style scoped>
  /* Можно добавить стили при необходимости */
  </style>